// @flow

import React from 'react';

import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink';
import { Icon } from 'Components/frameworks/icon/Icon';
import { TemplateString } from 'Components/frameworks/template-string/TemplateString';
import { Text } from 'Components/frameworks/text/Text';
import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';
import { TrackClick } from 'Tracking/track-click/TrackClick';

type Props = {
  author: string,
  date: string,
  fullCommentLink: string,
  link: CMSLink,
  onBy: string,
  stars: string,
  text: string,
};

const TRIPADVISOR_RATINGS_SVG = {
  '4': 'https://www.tripadvisor.fr/img/cdsi/img2/ratings/traveler/4.0-24206-5.svg',
  '5': 'https://www.tripadvisor.fr/img/cdsi/img2/ratings/traveler/5.0-24206-5.svg',
};

const QUOTATION_MARK_COLOR = '#E6EEF3';

export const TripadvisorTestimony = ({
  author,
  date,
  fullCommentLink,
  link,
  onBy,
  stars,
  text,
}: Props) => (
  <blockquote cite={fullCommentLink} className="flex flex-col items-center m-0 py-4">
    <div className="flex flex-col md:flex-row items-center justify-center w-full">
      <Icon
        className="md:self-start mb-4 rtl:mr-6"
        hasRtl
        name={ICONS.QUOTATION_MARK}
        style={{ color: QUOTATION_MARK_COLOR }}
        width="2rem"
      />
      <TrackClick
        as={DynamicLink}
        rel="nofollow"
        trackingData={{
          actionGA: 'push_content_testimony',
          labelGA: 'seeFullComment',
        }}
        url={fullCommentLink}
      >
        <Text
          theme="text-brand-1"
          text={text}
          color={COLORS.BLUE}
          className="text-center max-w-site-small"
        />
      </TrackClick>
      <Icon
        className="hidden md:inline-block self-end rtl:ml-6"
        hasRtl
        name={ICONS.QUOTATION_MARK}
        rotation={180}
        style={{ color: QUOTATION_MARK_COLOR }}
        width="2rem"
      />
    </div>
    <p className="flex flex-col md:flex-row items-center justify-center">
      <img src={TRIPADVISOR_RATINGS_SVG[stars]} className="md:rtl:mr-2 my-2 md:my-0" alt="" />
      <TemplateString
        className="text-center mt-1"
        dataTestId="tripadvisor-testimony-onby"
        template={onBy}
        values={{
          author,
          date,
        }}
        valuesClassName={{ author: 'font-bold', date: 'font-bold' }}
      />
      {link?.url && (
        <TrackClick
          as={DynamicLink}
          className="mt-1 md:rtl:ml-2 text-gray-darker underline"
          data-testid="tripadvisor-testimony-seemore"
          rel="nofollow"
          trackingData={{
            actionGA: 'push_content_testimony',
            labelGA: 'seeMore',
          }}
          url={link.url}
        >
          {link.label}
        </TrackClick>
      )}
    </p>
  </blockquote>
);
